import React from 'react'
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';
import { WarningTriangleIconNew, closePopup } from '../../style/images';
import { translate } from '../services';

const DialogContainer = (props) => {
	const { showConfirmation, toggleConfirmation, onLeave } = props;
	return (
		<Dialog open={showConfirmation} onClose={toggleConfirmation} PaperProps={{ sx: { position: "absolute", top: { md: "160px", xs: "295px" } } }}>
			<div className='show-confirmation'>
				<MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={toggleConfirmation} width="24px" height="24px" sx={{ position: "absolute", top: "12px", right: "12px", width: { md: "24px", xs: "20px" }, height: { md: "24px", xs: "20px" } }}>
					<Box sx={{ width: { md: "24px", xs: "20px" }, height: { md: "24px", xs: "20px" } }} component="img" src={closePopup}></Box>
				</MuiIconButton>
				<div className='content'>
					<div className='header'>
						<div className='warning-header'>
							<div className='warning-box'>
								<Box component="img" src={WarningTriangleIconNew}></Box>
							</div>
							<span className='header'>{translate("Warning")}</span>
						</div>

						<span>{translate("WARNING_CONFIGURATION_NOT_SAVED")}</span>
					</div>
				</div>
				<div className='footer'>
				<div className='primary-button' onClick={onLeave}>
						<span>{translate('Leave')}</span>
					</div>
					<div className='tertiary-button' onClick={toggleConfirmation}>
						<span>{translate("Cancel")}</span>
					</div>					
				</div>
			</div>
		</Dialog>
	)
}

export default DialogContainer